import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { OPERAND_TYPE_LIST } from '../constants';
import { assignParent } from '../creators/common';
/**
 * Add the provided operand at the end of the current list. If the provided value is also a list then it will be merged
 * into the current operand.
 *
 * @param operand Operand to add
 */
export function appendOperand(operand) {
  var _this$values;
  (_this$values = this.values).push.apply(_this$values, _toConsumableArray(operand.operandType === OPERAND_TYPE_LIST ? operand.values : [operand]));
  assignParent(this);
}